
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoaprendizajeComboReducer(state= initialState.cursoaprendizajeCombo, action){
	switch(action.type){
		case types.GET_CURSOAPRENDIZAJES_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}